<template>
  <search-provider
    :placename="placename"
    :selected-category-ids="[category.categoryId]"
    :data-lang="lang"
  />
</template>

<script setup lang="ts">
import { useNuxtApp, useRoute, createError } from 'nuxt/app'
import { computed } from 'vue'
import { httpHeadersCache } from '~/apps/search/helpers'
import { isSearchUrlRoute } from '~/apps/search/isSearchUrlComponent'
import { ensureArray } from '~/utility/array'
import CATEGORY_MAP from '../../json/catRoot.json'

// Page metadata
definePageMeta({
  key: 'CategorySearchPage',
  // Removed layout: false to use default layout at build time instead of runtime
  validate: (route) => isSearchUrlRoute(route),
  httpHeaders: (to) => httpHeadersCache(to),
})

const route = useRoute()
const { $gtm } = useNuxtApp()

if (!isSearchUrlRoute(route)) {
  throw createError({
    statusCode: 404,
    statusMessage: `Page Not Found: ${route.path}`,
    fatal: process.client,
  })
}

// Helper function
function findCategoryIdBySlug(slug: string): string | undefined {
  for (const [key, value] of Object.entries(CATEGORY_MAP)) {
    if (value === slug) {
      return key
    }
  }
  return undefined
}

// Computed properties
const lang = computed(() => route.params.lang || 'en-gb')

const placename = computed(
  () => ensureArray(route.query.placename)[0] || undefined,
)

const category = computed(() => {
  const categoryId = findCategoryIdBySlug(route.meta.type as string)
  return {
    categoryId,
    rootSlug: route.meta.type,
  }
})

// Watchers
watch(
  () => category.value,
  () => {
    void nextTick(() => {
      $gtm?.push({
        pageCategories: category.value.rootSlug,
      })
    })
  },
  { immediate: true },
)
</script>
